import { IOfferForClientSchema } from '../../repositories/chats/entities/for_client/OfferForClientSchema';
import { TThunkAction } from '../../types/redux/thunk';
import { createOutcomingMessage } from '../../utils/messageUtils';
import { setSendMessagePending } from '../sendMessage';
import { sendWsMessage } from '../wsMessage';

interface IProps {
  offer: IOfferForClientSchema;
  chatId: string;
  messageId?: string;
}

export const sendOfferMessage =
  ({ offer, chatId, messageId }: IProps): TThunkAction<void> =>
  async (dispatch, getState, context) => {
    const {
      user: { userId },
    } = getState();

    const message = createOutcomingMessage({ uid: messageId, chatId, userId, type: 'offer' });
    message.offers = [offer];

    dispatch(
      setSendMessagePending({
        message: { ...message, offers: [offer] },
        messageId: messageId || message.messageId,
        messagesMap: context.custom.messagesMap,
      }),
    );

    await dispatch(sendWsMessage({ message, offers: [offer] }));
  };
